import { Injectable } from '@angular/core';
import { BillingService } from 'src/app/services/billing/billing.service';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import cloneDeep from 'lodash/cloneDeep';
import { UserService } from 'src/app/services/user.service';
import { triggerAnalyticsEvent } from 'src/app/utils/analytics/trigger-analytics';
import { RAISE_A_TICKET_CLICK } from 'src/app/constants/analytics-track-events';

const DEFAULT_TICKET_URL =
  'https://forms.clickup.com/3443930/f/3936u-47676/DG3JIOB7ZT1CROWV9D';
@Injectable({
  providedIn: 'root',
})
export class GenerateTicketURLService {
  user: any;
  contextURLStack = [];

  constructor(
    private featureFlagService: FeatureFlagsService,
    private billingService: BillingService,
    private userService: UserService,
  ) {}

  getClickUpTicketURL() {
    const ticketUrl =
      this.featureFlagService?.getClickupTicketUrl() || DEFAULT_TICKET_URL;

    if (this.featureFlagService?.isSaaSCP) {
      return this.generateClickUpTicketUrlForSaaS(ticketUrl);
    }

    return this.generateClickUpTicketUrlForPaaS(ticketUrl);
  }

  generateClickUpTicketUrlForPaaS(clickupTicketUrl) {
    return clickupTicketUrl?.length > 0
      ? `${clickupTicketUrl}?URL=${window.location.href}&Reported%20by=${this.userService?.user?.name}`
      : '';
  }

  generateClickUpTicketUrlForSaaS(saasFormURL): string {
    const email = this.userService?.user?.name;
    const cpUrl = window.location.href;
    // Determine if the user has an active support plan
    const hasSupportPlan = this.billingService.billingDetails?.some(
      (plan) => plan?.planName === 'SUPPORT_PLAN' && plan?.status === 'ACTIVE',
    );
    const plan = hasSupportPlan ? 'Yes' : 'No';
    const encodedEmail = encodeURIComponent(email);
    return `${saasFormURL}?email=${encodedEmail}&Reported%20by=${encodedEmail}&url=${encodeURIComponent(
      cpUrl,
    )}&plan=${encodeURIComponent(plan)}`;
  }

  handleRaiseATicketAction() {
    triggerAnalyticsEvent(RAISE_A_TICKET_CLICK);
    let enterpriseCustomerName =
      this.featureFlagService?.getEnterpriseCustomerName();

    let ticketUrl =
      enterpriseCustomerName === 'mercedes'
        ? this.featureFlagService?.getClickupTicketUrl()
        : this.getClickUpTicketURL();

    window.open(ticketUrl);
  }
}
